<template>
  <div class="fixed-plugin ps" :class="show ? 'show' : ''">
    <div class="overlay" @click.self="close">
      <div class="card shadow-lg overflow-auto" :class="'card-' + size">
        <div class="card-header d-flex justify-content-between align-items-center">
          <div >
            <h5 class="mb-0">{{ title }}</h5>
          </div>
          <div >
            <button
              class="btn mb-0"
              @click="close"
            >
              <i class="fa fa-close" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <!-- <hr class="horizontal dark my-1" /> -->
        <div class="card-body pt-sm-3 pt-0">
          <slot name="body"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean,
    title: {
      type: String,
      required: true,
      default: "Sidebar",
    },
    size: {
      type: String,
      required: true,
      default: "md",
    },
  },
  methods: {
    close() {
      this.$emit("on-close");
    },
  },
};
</script>

<style>
</style>